import { createSelector } from 'reselect';
import { RootStoreModel } from '@redux/reducers';
import { ColumnSettingModel } from '@redux/models';
import { DataNode } from "antd/lib/tree";
import { OrganizationNodepProps } from '@axios/models';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
export interface treeNode extends DataNode{
  maxDepth:number;
}

export const formatOrgsOptions = (state: RootStoreModel): treeNode[] => {
  const orgsTree = state.userState.orgsTree;
  var maxDepth =0;
  const formatData = (treeList: OrganizationNodepProps[],dep:number): treeNode[] => {
    dep++;
    if(dep>maxDepth){
      maxDepth=dep;
    }
    return treeList.map((tree) => {
      const { id, name, level, sort, organizations } = tree;
      const children = formatData(organizations,dep);
      return {
        title: name,
        key: id,
        value: id,
        // level: level,
        maxDepth:0,
        children: children,
      };
    });
  };

  var tree =formatData(orgsTree, 0);
  //console.log("formatOrgsOptions",maxDepth);
  if(tree.length>0){
    tree[0].maxDepth= maxDepth; 
  }
 
  return tree;
}


export const getOrgsOptionsSelector = createSelector(
  formatOrgsOptions,
  (res) => res
);




